import React from "react";
import { Accordion, AccordionItem } from "Components/Accordion";
import WayPoints from "Components/Waypoints";

interface Props {
  suggestedTrails: any;
}

const ADATrails = (props: Props) => {
  const { suggestedTrails } = props;

  const trailStopMap = {};
  const trailsSortedByOrder = suggestedTrails.sort(
    (a: any, b: any) => a.order - b.order
  );
  trailsSortedByOrder.forEach((trail: any) => {
    trailStopMap[trail.name] = [];
    trail.Stops.forEach((stop: any) => {
      trailStopMap[trail.name].push(stop.title);
    });
  });

  return (
    <Accordion>
      {Object.keys(trailStopMap).map((trailName: any) => {
        // only want to display Trails that have associated destinations
        if (trailStopMap[trailName].length > 0) {
          const trailAccordionId = trailName.replace(/ /g, "-");
          return (
            <AccordionItem id={trailAccordionId} title={trailName}>
              <WayPoints steps={trailStopMap[trailName]} showTitle={false} />
            </AccordionItem>
          );
        }
        return null;
      })}
    </Accordion>
  );
};

export default ADATrails;

//  <ul>
//       <li>Stoney Brook Museum</li>
//       <li>Arts Center</li>
//       <li>Sociology Building</li>
//     </ul>

//   <AccordionItem id="trails-2" title="Athletics">

//   </AccordionItem>
try {
    // @ts-ignore
    ADATrails.displayName = "ADATrails";
    // @ts-ignore
    ADATrails.__docgenInfo = { "description": "", "displayName": "ADATrails", "props": { "suggestedTrails": { "defaultValue": null, "description": "", "name": "suggestedTrails", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/ADATrails/ADATrails.tsx#ADATrails"] = { docgenInfo: ADATrails.__docgenInfo, name: "ADATrails", path: "src/shared/components/ADATrails/ADATrails.tsx#ADATrails" };
}
catch (__react_docgen_typescript_loader_error) { }